import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Address_Update_Mutation = graphql(`
  mutation ThirdPartyForm_Address_Update(
    $addressId: Id!
    $thirdPartyId: Id!
    $update: AddressInput!
    $versionData: VersionDataInput
  ) {
    updateThirdPartyAddress(
      addressId: $addressId
      multiAddressableId: $thirdPartyId
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateThirdPartyAddressMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Address_Update_Mutation);
